import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Observable } from 'rxjs';

import { DcIcons } from '../../../../ui/app-dc.icons';

export enum FilterModelAction {
	Delete = 'delete',
}

export interface IFilterModelConfirmationModalData {
	filterModelId: string | Array<string>;
	element: string;
	action: FilterModelAction;
}

@Component({
	selector: 'app-filter-model-action-confirm-popup',
	templateUrl: './filter-model-action-confirm-popup.component.html',
	styleUrls: ['./filter-model-action-confirm-popup.component.scss'],
})
export class FilterModelActionConfirmPopupComponent<
	T extends IFilterModelConfirmationModalData
> extends DcBaseComponent {
	protected readonly FilterModelAction = FilterModelAction;
	protected readonly DcIcons = DcIcons;

	public vo$: Observable<{
		element: string;
		filterModelId: string | Array<string>;
		action: FilterModelAction;
		isMultipleElement: boolean;
	}>;

	public confirmDeletion = false;

	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'filter-model-action-confirm-popup';

		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement: Array.isArray(this.modalData.filterModelId),
			filterModelId: this.modalData.filterModelId,
			action: this.modalData.action,
		});
	}

	public launchAction(): void {
		this.modalService.closeActiveModal({
			shouldLaunch: true,
		});
	}
}
